<div class="right-sidenav-content">
  <mat-tab-group fitInkBarToContent #rightSidenavTabGroup (selectedIndexChange)="onSelectedTabChange($event)">
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="tab-label">
          <div>Friends</div>
        </div>
      </ng-template>

      <div class="ac-flex ac-algn-ctr ac-gap-sm ac-headline-sm ac-mg-xl-0 friends-header">
        <ac-icon class="tab-icon" iconKey="hr:people" [size]="32" />
        <div>Friends</div>
      </div>

      <app-friends-list />
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="tab-label">Chat</div>
      </ng-template>
      <div class="ac-flex ac-algn-ctr ac-gap-sm ac-headline-sm ac-mg-xl-0">
        <ac-icon class="tab-icon" iconKey="hr:chat_bubble" />
        <div>Global Chat</div>
      </div>
      <app-chat />
    </mat-tab>
  </mat-tab-group>
</div>
